import React from 'react';
import PropTypes from 'prop-types';

import useBackdropController from './useBackdropController';
import BackdropOverlay from './Backdrop';
import OverlayContext from './Context';

const Provider = ({ children, position }) => {
  const [open, showOverlay, hideOverlay, showOverlayWhile] =
    useBackdropController();
  const contextValue = React.useMemo(
    () => ({
      showOverlay,
      hideOverlay,
      showOverlayWhile,
      position,
    }),
    [showOverlay, hideOverlay, showOverlayWhile, position]
  );

  return (
    <OverlayContext.Provider value={contextValue}>
      {children}
      <BackdropOverlay open={open} />
    </OverlayContext.Provider>
  );
};

Provider.propTypes = {
  children: PropTypes.node,
  position: PropTypes.oneOf(['absolute', 'fixed']),
};

export default Provider;
